export enum GlobalSearchAppURI {
  CLAIMS_APP = 'claims/claim-details/{{0}}',
  DISPUTES_APP = 'disputes/disputes/view-dispute/{{0}}/{{1}}',
  INVOICE_APP = 'invoice-auditor/invoicing/{{0}}',
  SHIPMENT_DETAILS_APP = 'disputes/shipment-detail/{{0}}',
}
